import { useState, useEffect } from 'react';

import { getScheduledReportConfigurations, getReportDeliveries, deleteScheduledReportConfiguration } from '../../../api/appServices';
import { getSavedReports, deleteSavedReport, postSavedReport, putSavedReport } from '../../../api/attribution';

export const useSavedReports = () => {
  const [savedReports, setSavedReports] = useState([]);
  const [scheduledReports, setScheduledReports] = useState([]);
  const [reportDeliveries, setReportDeliveries] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleGetSavedReports = () => (
    getSavedReports()
      .then(saved => setSavedReports([...saved]))
  );

  const handleGetScheduledReports = () => (
    getScheduledReportConfigurations()
      .then(saved => setScheduledReports([...saved.data]))
  );

  const handleGetReportDeliveries = () => (
    getReportDeliveries()
      .then(saved => setReportDeliveries([...saved.data].sort((a, b) => b.delivery_timestamp.localeCompare(a.delivery_timestamp))))
  );

  useEffect(() => {
    setLoading(true);
    Promise.all([
      handleGetSavedReports(),
      handleGetScheduledReports(),
      handleGetReportDeliveries(),
    ])
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, []);

  const deleteReport = id => (
    deleteSavedReport(id)
      .then(() => {
        handleGetSavedReports();
      })
  );

  const deleteScheduledReport = id => (
    deleteScheduledReportConfiguration(id)
      .then(() => {
        handleGetScheduledReports();
      })
  );

  const postReport = data => (
    postSavedReport(data)
      .then(x => {
        handleGetSavedReports();
        return x;
      })
  );

  const updateReport = (data, id) => (
    putSavedReport(data, id)
      .then(x => {
        handleGetSavedReports();
        return x;
      })
  );

  return {
    loading,
    savedReports, setSavedReports, handleGetSavedReports,
    scheduledReports,
    deleteScheduledReport,
    handleGetScheduledReports,
    reportDeliveries,
    deleteSavedReport: deleteReport,
    postSavedReport: postReport,
    updateSavedReport: updateReport,
  };
};
